// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UserIndexedDB, UserIndexedDBStore } from '@shared/commons/DataBase/UserIndexedDB';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { WatchlistSheets, _WatchlistSheets } from './WatchlistSheets';
import { UserWebStorageInstance } from '../../../user-web-storage';
import { ClientType } from '../../ClientType';
import { BaseStorageManager } from '../BaseStorageManager';
class _WatchlistSheetsStorageManager extends BaseStorageManager {
    wasChanged() {
        if (ClientType.IsWebMobile()) {
            this.wasSyncedOut = false;
        }
        super.wasChanged();
    }
    onRestoreAsync(sheets) {
        return __awaiter(this, void 0, void 0, function* () {
            WatchlistSheets.restore(sheets);
        });
    }
    serializeData() {
        return _WatchlistSheets.serialize(WatchlistSheets.items);
    }
    deserializeDataAsync(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield Promise.resolve(_WatchlistSheets.deserialize(data));
        });
    }
    fetchRemoteSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const dbRecord = yield UserWebStorageInstance.settings.getWatchlistSheets();
            const updateTimeSpan = (_a = dbRecord === null || dbRecord === void 0 ? void 0 : dbRecord.updateTimeSpan) !== null && _a !== void 0 ? _a : 0;
            if (!isNullOrUndefined(dbRecord) && updateTimeSpan !== 0) {
                return dbRecord;
            }
            const wlSheetitems = yield SessionSettings.requestDefaultWatchlistLists();
            if (wlSheetitems.length > 0) {
                return {
                    settings: _WatchlistSheets.serialize(wlSheetitems),
                    updateTimeSpan: +new Date()
                };
            }
            // empty watchlist sheets
            return {
                settings: _WatchlistSheets.serialize([]),
                updateTimeSpan: 0
            };
        });
    }
    sendRemoteSettings(dbRecord) {
        return __awaiter(this, void 0, void 0, function* () {
            yield UserWebStorageInstance.settings.postWatchlistSheets(dbRecord);
        });
    }
}
export const WatchlistSheetsStorageManager = new _WatchlistSheetsStorageManager(UserIndexedDB, UserIndexedDBStore.WL_SHEETS);
